import React from 'react';
import { connect } from 'react-redux';
import infiniteScrollSelector from 'Selectors/infiniteScrollSelector';

const inThreadAdComponent = ( { adContainerId, className } ) => {
	className = "inThreadAd-placeholder " + className;

	return (
		<div className={ className } ><div id={ adContainerId } /></div>
	);
};

export default connect( infiniteScrollSelector )( inThreadAdComponent );



// WEBPACK FOOTER //
// ./src/components/ads/inThreadAdComponent.js